import api.FirebaseConfig
import api.data.DataProperty
import api.data.DataPropertyInquiry
import api.data.DataPropertyOwner
import api.data.DataVisitSchedule
import api.data.response.DataAdminProfile
import api.repository.adminProfile.ImplRepositoryAdminProfile
import api.repository.auth.ImplRepoAuthentication
import api.repository.properties.ImplRepositoryProperties
import api.repository.propertyInquiries.ImplRepositoryPropertyInquiries
import api.repository.propertyOwners.ImplRepositoryPropertyOwners
import api.repository.visitScheduler.ImplRepositoryVisitScheduler
import api.service.adminProfile.ImplServiceAdminProfile
import api.service.auth.ImplServiceAuthentication
import api.service.properties.ImplServiceProperties
import api.service.propertyInquiries.ImplServicePropertyInquiries
import api.service.propertyOwners.ImplServicePropertyOwners
import api.service.visitScheduler.ImplServiceVisitScheduler
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.storage.storage
import kotlinx.browser.window
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import react.FC
import react.Props
import react.create
import react.dom.client.createRoot
import react.dom.html.ReactHTML.div
import react.router.Route
import react.router.Routes
import routes.EnumRoutes
import ui.AdminLogin
import ui.Inquiries
import ui.OwnerSubmissions
import ui.PageAddProperty
import ui.PageEditProperty
import ui.PageProperties
import ui.PagePropertyListing
import ui.PageVisitSchedule
import ui.uiAdminProfile.PageAdminProfile
import utils.WebHeader
import utils.WebsiteDetails
import web.cssom.ClassName
import web.dom.document
import web.html.HTMLElement
import web.url.URLSearchParams

val firebaseInit = FirebaseConfig.init()
val firebaseAuth = Firebase.auth(firebaseInit)
val firebaseFirestore = Firebase.firestore(firebaseInit)
val firebaseStorage = Firebase.storage(firebaseInit)
var dataAdminProfile: DataAdminProfile = DataAdminProfile()
var dataProperties: ArrayList<DataProperty> = ArrayList<DataProperty>()
var dataOwners: ArrayList<DataPropertyOwner> = ArrayList<DataPropertyOwner>()
var dataInquiries: ArrayList<DataPropertyInquiry> = ArrayList<DataPropertyInquiry>()
var dataVisitSchedules: ArrayList<DataVisitSchedule> = ArrayList<DataVisitSchedule>()


fun main(){
    window.onload = {
        createRoot(document.head).render(
            WebHeader.create() {
                websiteName = WebsiteDetails.WebsiteName.itemName
                websiteUrl = WebsiteDetails.WebsiteUrl.itemName
                websiteEmail = WebsiteDetails.WebsiteEmail.itemName
                websitePhone = WebsiteDetails.WebsitePhone.itemName
                websiteRegion = WebsiteDetails.WebsiteRegion.itemName
                websiteIcon = WebsiteDetails.WebsiteIcon.itemName
                websiteEmail = WebsiteDetails.WebsiteEmail.itemName
                websiteDescription = WebsiteDetails.WebsiteDescription.itemName
                websiteClassification = WebsiteDetails.WebsiteClassification.itemName
                websiteTagLine = WebsiteDetails.WebsiteTagLine.itemName
                websiteCountryName = WebsiteDetails.WebsiteCountryName.itemName
                newKeywordsMeta = arrayOf(WebsiteDetails.WebsiteKeyWords.itemName)
            }
        )
        val root = document.createElement("section")
        document.body.appendChild(root)
//        createRoot(root).render(SignedOutUserApp.create())

        CoroutineScope(Dispatchers.Main).launch {
            val currentUser = getCurrentUser()
            if (currentUser){
                val adminData = getAdminData()
                getProperties()
                getOwnerSubmission()
                dataVisitSchedules = getVisitSchedule()
                routesFromUrl(signedInUser = currentUser, userData = adminData, root)
            } else{
                routesFromUrl(signedInUser = false, userData = null, root)
            }
        }
    }
}

private fun routesFromUrl(signedInUser: Boolean, userData: DataAdminProfile?, root: HTMLElement){
    if (signedInUser && userData != null){
        createRoot(root).render(MainApp.create())
    } else{
        createRoot(root).render(SignedOutUserApp.create())
    }
}

val MainApp = FC<Props> {
    Routes.create() {
        Route {
            when (window.location.pathname) {
                EnumRoutes.Dashboard.routeID -> {
                    this@FC.apply {
                        Dashboard(){
                        }
                    }
                }
                EnumRoutes.Properties.routeID -> {
                    this@FC.apply {
                        div{
                            className = ClassName("min-h-screen bg-background flex overflow-hidden")
                            PageProperties()
                        }
                    }
                }
                EnumRoutes.PropertyListing.routeID -> {
                    val id = URLSearchParams(window.location.search)["id"]
                    if (!id.isNullOrEmpty()){
                        val dataProperty = dataProperties.firstOrNull { property ->
                            property.id == id
                        }
                        if (dataProperty != null){
                            this@FC.apply {
                                div{
//                            className = ClassName("min-h-screen bg-background flex overflow-hidden")
                                    PagePropertyListing(){
                                        property = dataProperty
                                    }
                                }
                            }

                        }
                        else {
                            this@FC.apply {
                                div{
                                    className = ClassName("min-h-screen bg-background flex overflow-hidden")
                                    PageProperties(){}
                                }
                            }
                        }

                    }
                    else {
                        this@FC.apply {
                            div{
                                className = ClassName("min-h-screen bg-background flex overflow-hidden")
                                PageProperties()
                            }
                        }
                    }

                }
                EnumRoutes.EditProperty.routeID -> {
                    val id = URLSearchParams(window.location.search)["id"]
                    if (!id.isNullOrEmpty()){
                        val dataProperty = dataProperties.firstOrNull { property ->
                            property.id == id
                        }
                        if (dataProperty != null){
                            this@FC.apply {
                                div{
//                            className = ClassName("min-h-screen bg-background flex overflow-hidden")
                                    PageEditProperty(){
                                        property = dataProperty
                                    }
                                }
                            }

                        }
                        else {
                            this@FC.apply {
                                div{
                                    className = ClassName("min-h-screen bg-background flex overflow-hidden")
                                    PageProperties()
                                }
                            }
                        }

                    }
                    else {
                        this@FC.apply {
                            div{
                                className = ClassName("min-h-screen bg-background flex overflow-hidden")
                                PageProperties()
                            }
                        }
                    }

                }
                EnumRoutes.ScheduledVisit.routeID -> {
                    this@FC.apply {
                        PageVisitSchedule(){
                            this.visitSchedule = dataVisitSchedules

                        }
                    }
                }
                EnumRoutes.AdminProfile.routeID -> {
                    this@FC.apply {
                        PageAdminProfile{

                        }
                    }
                }
                EnumRoutes.PropertyInquiries.routeID -> {
                    this@FC.apply {
                        Inquiries{
                        }
                    }
                }
                EnumRoutes.OwnerSubmissions.routeID -> {
                    this@FC.apply {
                        OwnerSubmissions{
                        }
                    }
                }
                EnumRoutes.AddProperty.routeID -> {
                    this@FC.apply {
                        PageAddProperty{
                        }
                    }
                }
                EnumRoutes.AdminLogin.routeID -> {
                    this@FC.apply {
                        AdminLogin()
                    }
                }

            }
        }
    }

}

val SignedOutUserApp = FC<Props> {
        AdminLogin()
}

 suspend fun getCurrentUser(): Boolean {
    val implAuthRepo = ImplRepoAuthentication(ImplServiceAuthentication).checkCurrentUser()
    return implAuthRepo
}

 suspend fun getAdminData(): DataAdminProfile?{
    val implAdminData = ImplRepositoryAdminProfile(ImplServiceAdminProfile).getAdminProfile()
     if (implAdminData != null) {
         dataAdminProfile = implAdminData
     }
    return implAdminData
}

suspend fun getProperties(): ArrayList<DataProperty>?{
    val implProperties = ImplRepositoryProperties(ImplServiceProperties).getProperties()
    if (implProperties != null){
        dataProperties = implProperties
    }
    return implProperties
}

suspend fun getOwnerSubmission(): ArrayList<DataPropertyOwner>?{
    val implOwnerSubmissions = ImplRepositoryPropertyOwners(ImplServicePropertyOwners()).getPropertyOwners()
    if (implOwnerSubmissions != null){
        dataOwners = implOwnerSubmissions
    }
    return dataOwners
}

suspend fun getInquiries(): ArrayList<DataPropertyInquiry>{
    val implInquiries = ImplRepositoryPropertyInquiries(ImplServicePropertyInquiries()).getPropertyInquiries()
    if (implInquiries != null){
        dataInquiries = implInquiries
    }
    return dataInquiries
}

suspend fun getVisitSchedule(): ArrayList<DataVisitSchedule>{
    val implVisitSchedules = ImplRepositoryVisitScheduler(ImplServiceVisitScheduler()).getVisitSchedules()
    if (implVisitSchedules != null){
        dataVisitSchedules = implVisitSchedules
    }
    return dataVisitSchedules
}